import BaseButton from './Button';

// EXPORT
export const Button = BaseButton;
export type { ButtonProps } from './Button.interface';
